<template>
  <div
    style="width: 100%;min-width:1024px;"
    v-loading="loading"
    :element-loading-text="loadingText"
  >
      <div style="width: 90%;min-width: 1024px;margin: 0px auto;">
        <el-input
          v-model="searchCondition.name"
          placeholder="项目名称"
          :style="searchNameStyle"
        >
        </el-input>
        <el-input
          v-model="searchCondition.templateName"
          placeholder="项目类型"
          style="width: 150px;margin: 0 10px;"
        >
        </el-input>
        <el-input
          v-if="type != 'myself'"
          v-model="searchCondition.creatorName"
          placeholder="编制人"
          style="width: 150px;margin-right: 10px;"
        >
        </el-input>
        <el-date-picker
          type="date"
          placeholder="开始时间"
          :clearable="false"
          style="width:140px;margin-right: 10px;"
          v-model="searchCondition.startTime">
        </el-date-picker>
        <span style="font-size: 20px;margin-top:5px;">-</span>
        <el-date-picker
          type="date"
          placeholder="结束时间"
          :clearable="false"
          style="width:140px;margin: 0 10px;"
          v-model="searchCondition.endTime">
        </el-date-picker>
        <el-button
          type="primary"
          style="width: 80px;"
          v-on:click="requestPage(1)"
          >筛选
        </el-button>
      </div>
      <el-table
        :data="tableData"
        style="width: 90%;min-width: 1024px;margin: 10px auto;"
      >
        <el-table-column
          prop="name"
          label="项目名称"
          min-width="200"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="projectTemplate.name"
          label="项目类型"
          min-width="100"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="overgroundArea"
          label="地上建筑面积"
          min-width="100"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="undergroundArea"
          label="地下建筑面积"
          min-width="100"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          v-if="type != 'total_model'"
          prop="totalCost"
          label="总造价(万元)"
          min-width="110"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="implementTime"
          label="实施时间"
          min-width="100px"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          v-if="type != 'myself'"
          prop="creator.nickName"
          label="编制人"
          min-width="100px"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          v-if="type != 'total_model'"
          label="详情"
          min-width="50px"
          align="center">
          <template slot-scope="scope">
            <el-button @click="handleClick('edit', scope.row)" type="text" size="small">
              查看
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          v-if="type != 'total_model'"
          label="项目文件"
          min-width="80px"
          align="center">
          <template slot-scope="scope">
            <el-button @click="handleClick('files', scope.row)" type="text" size="small">
              查看
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="三维模型"
          min-width="90px"
          align="center">
          <template slot-scope="scope">
            <el-button
              @click="modelClick('view', scope.row)"
              type="text"
              size="small"
              v-if="scope.row.model === 1 || scope.row.model2 !== null"
              style="margin-right:5px;"
              >浏览
            </el-button>
            <el-button
              @click="modelClick('create', scope.row)"
              type="text"
              size="small"
              v-if="scope.row.model2 === null && scope.row.model === 0"
              style="margin-right:5px;"
              >创建
            </el-button>
            <el-upload
                :action="'http://www.scbimzjzb.cn/projectcost/api/model/upload_model/' + scope.row.id"
                :limit="1"
                with-credentials
                :show-file-list="false"
                accept=".zip"
                :name="'file'"
                :file-list="fileList"
                :before-upload="beforeUpload"
                :on-success="onUploadSuccess"
                :on-error="onUploadError"
                :style="uploadStyle(scope.row)"
            >
                <el-button
                  type="text"
                  size="small"
                >上传
                </el-button>
            </el-upload>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin: 20px 0px 10px 0px;">
        <el-pagination
          layout="prev, pager, next, jumper"
          :page-size="pageSize"
          :total="totalSize"
          style="text-align: center;"
          @current-change="changePage"
        >
        </el-pagination>
      </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectCostEstimateList',

  methods: {
    handleClick (type, row) {
      if (type === 'edit') {
        this.$router.push('/edit_project_cost_estimate/' + this.$props.type + '/' + row.id)
      } else if (type === 'files') {
        this.$router.push('/project_files/' + this.$props.type + '/' + row.id)
      }
    },

    modelClick (type, row) {
      if (type === 'view') {
        if (row.model === 1) {
          this.$router.push('/3d_building/upload/' + row.id + '/view')
        } else if (row.model2 !== null) {
          this.$router.push('/3d_building/build/' + row.id + '/' + row.model2)
        }
      } else if (type === 'create') {
        this.$router.push('/3d_building/build/' + row.id + '/new')
      }
    },

    uploadStyle (row) {
      var style = {
        display: 'inline-block'
      }
      if (row.model === 1) {
        style['margin-left'] = '5px'
      }
      return style
    },

    beforeUpload (file) {
      this.$data.loading = true
      this.$data.loadingText = '三维模型上传中'
    },

    onUploadSuccess (id) {
      var self = this
      this.$data.fileList = []
      this.putRequest('/cost_estimates/' + id + '/model_uploaded')
        .then(resp => {
          self.$data.loading = false
          if (resp && resp.code === 200) {
            this.$message.success({ message: '上传成功' })
            for (var i = 0; i < self.$data.tableData.length; i++) {
              if (self.$data.tableData[i].id === id) {
                self.$data.tableData[i].model = 1
                break
              }
            }
          } else {
            this.$message.error({ message: '上传失败，请重试' })
          }
        })
    },

    onUploadError (err, file, fileList) {
      console.log(err)
      this.$message.error({ message: '上传失败，请重试' })
      this.$data.fileList = []
      this.$data.loading = false
    },

    changePage (page) {
      this.requestPage(page)
    },

    requestPage (page) {
      var self = this
      this.$data.searchCondition.page = page
      this.$data.searchCondition.size = this.$data.pageSize
      this.$data.loading = true
      this.$data.loadingText = ''
      this.postRequest('/cost_estimates', this.$data.searchCondition)
        .then(resp => {
          self.$data.loading = false
          if (resp && resp.result) {
            var projectCostEstimates = resp.result.content
            for (var i = 0; i < projectCostEstimates.length; i++) {
              // var time = new Date(projectCostEstimates[i].implementTime)
              // projectCostEstimates[i].implementTime = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate()
              projectCostEstimates[i].implementTime = projectCostEstimates[i].implementTime.split('T')[0]
              projectCostEstimates[i].totalCost = self.Utils.formatNum((projectCostEstimates[i].totalCost / 10000).toFixed(4))
              projectCostEstimates[i].overgroundArea = projectCostEstimates[i].overgroundArea.toString().replace(new RegExp('\\B(?=(\\d{3})+\\b)', 'g'), ',')
              projectCostEstimates[i].undergroundArea = projectCostEstimates[i].undergroundArea.toString().replace(new RegExp('\\B(?=(\\d{3})+\\b)', 'g'), ',')
            }
            self.$data.tableData = projectCostEstimates
            self.$data.totalSize = resp.result.totalElements
          }
        })
    }
  },

  props: {
    type: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      loading: false,
      loadingText: '',
      tableData: [],
      totalSize: 0,
      pageSize: 10,
      fileList: [],
      searchCondition: {
        type: '',
        name: '',
        templateName: '',
        creatorName: '',
        startTime: null,
        endTime: null,
        page: 1,
        size: 10
      }
    }
  },

  mounted () {
    if (this.$props.type === 'myself') {
      this.$data.searchCondition.type = 'myself'
    }
    this.requestPage(1)
  },

  computed: {
    searchNameStyle () {
      var style = {
        width: '150px',
        'margin-left': 'calc(100% - 883px)'
      }
      if (this.$props.type === 'myself') {
        style['margin-left'] = 'calc(100% - 723px)'
      }
      return style
    }
  }
}
</script>

<style scoped></style>
